var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1459.13 1060.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ede4dd;}.cls-2{fill:#565697;}.cls-3{fill:#bcdde8;}.cls-4{fill:#1d1e40;}.cls-5{fill:#fcca5f;}.cls-6{fill:#fff;}.cls-10,.cls-12,.cls-17,.cls-20,.cls-21,.cls-22,.cls-23,.cls-25,.cls-26,.cls-27,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-7,.cls-8{fill:none;}.cls-19,.cls-20,.cls-7,.cls-8{stroke:#1d1e40;}.cls-10,.cls-12,.cls-17,.cls-21,.cls-25,.cls-26,.cls-27,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-7,.cls-8{stroke-linecap:round;}.cls-10,.cls-12,.cls-17,.cls-25,.cls-26,.cls-27,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-7,.cls-8{stroke-linejoin:round;}.cls-7{stroke-width:2.82px;}.cls-10,.cls-12,.cls-25,.cls-26,.cls-27,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-8{stroke-width:1.41px;}.cls-9{fill:#cecece;}.cls-10,.cls-32,.cls-33,.cls-34{stroke:#fff;}.cls-11,.cls-15{fill:#efb6ab;}.cls-12{stroke:#532210;}.cls-13{fill:#e69766;}.cls-14{fill:#9d4e49;}.cls-15{opacity:0.72;}.cls-15,.cls-18{isolation:isolate;}.cls-16{fill:#221f1f;}.cls-17{stroke:#9d4e49;stroke-width:5.64px;}.cls-18{fill:#d8877c;opacity:0.66;}.cls-19{fill:#fcfcfc;}.cls-19,.cls-20,.cls-21,.cls-22,.cls-23{stroke-miterlimit:10;}.cls-19,.cls-20{stroke-width:1.88px;}.cls-21,.cls-22,.cls-23,.cls-35{stroke:#221f1f;}.cls-21{stroke-width:7.52px;}.cls-22,.cls-23{stroke-width:1.59px;}.cls-23{stroke-dasharray:9.81 9.81;}.cls-24{fill:#e65557;}.cls-25,.cls-26,.cls-27{stroke:#870f0f;}.cls-26{stroke-dasharray:6 6;}.cls-27{stroke-dasharray:5.16 5.16;}.cls-28{fill:#a26d4b;}.cls-29,.cls-31{stroke:#a26d4b;}.cls-29{stroke-width:4.7px;}.cls-30{fill:#cb4646;}.cls-32{stroke-dasharray:7.74 7.74;}.cls-33{stroke-dasharray:7.75 7.75;}.cls-34{stroke-dasharray:7.6 7.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    "data-name": "Layer 26"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 739.17,
    cy: 878.9,
    rx: 549.46,
    ry: 82.18
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M900.69,743.34H167.53a21.86,21.86,0,0,1-21.78-21.78V256.48a21.86,21.86,0,0,1,21.78-21.78H900.68a21.86,21.86,0,0,1,21.78,21.78V721.56A21.81,21.81,0,0,1,900.69,743.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M863.6,693.67H205.89a16.76,16.76,0,0,1-16.77-16.76V293.53a16.77,16.77,0,0,1,16.77-16.77H863.6a16.77,16.77,0,0,1,16.76,16.77V676.91A16.75,16.75,0,0,1,863.6,693.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 456.16,
    y: 743.08,
    width: 163.31,
    height: 78.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.52,852.35H411.13A15.38,15.38,0,0,1,395.79,837h0a15.37,15.37,0,0,1,15.34-15.33H663.52A15.37,15.37,0,0,1,678.86,837h0A15.38,15.38,0,0,1,663.52,852.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M846.33,487.81H667.62a10.74,10.74,0,0,1-10.73-10.73v-17.7a10.74,10.74,0,0,1,10.73-10.73H846.33a10.74,10.74,0,0,1,10.73,10.73v17.7A10.73,10.73,0,0,1,846.33,487.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M846.68,595H668.2a10.85,10.85,0,0,1-10.84-10.84v-17.5a10.85,10.85,0,0,1,10.84-10.84H846.68a10.85,10.85,0,0,1,10.85,10.84v17.5A10.86,10.86,0,0,1,846.68,595Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M850.44,533.22h-129a5.84,5.84,0,0,1-5.84-5.85V516.73a5.83,5.83,0,0,1,5.84-5.84h129a5.84,5.84,0,0,1,5.85,5.84v10.64A5.85,5.85,0,0,1,850.44,533.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 538.75,
    cy: 256.88,
    r: 6.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M625.54,723.22H451.05a2.33,2.33,0,0,1-2.33-2.33v-5.64a2.33,2.33,0,0,1,2.33-2.33H625.54a2.33,2.33,0,0,1,2.33,2.33v5.64A2.35,2.35,0,0,1,625.54,723.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M189.12,523.18V678.11a15.55,15.55,0,0,0,15.56,15.54l135.58-.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M709.89,694.8H864.82a15.55,15.55,0,0,0,15.54-15.56l-.23-135.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M319.87,276.07H201.56c-6.55,0-11.87,4.71-11.85,10.52l.16,91.69"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M416.73,277.5s-34.77,3.27-58,27.08c-16.22,16.59-51.29,156-34.32,182.12s42.7,9.79,42.7,9.79-12.59,168.64-26.82,196.92c79.14.58,247.41,0,247.41,0S537.87,527.5,539.51,437.2c31.42,26.11,52.54,31,52.54,31s87.58-51.68,96.88-66.9-2.74-64.75-13.68-65.82S607.37,375.2,588.76,391c-11.5-16.31-45.42-74-59.12-89.76C518.31,288.11,479.87,265.67,416.73,277.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "410.45 505.23 378.5 516.81 378.5 530.89 416.35 519.48 416.35 502.94 410.45 505.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "513.65 495.74 513.65 511.92 538.75 518.56 538.75 504.88 513.65 495.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M534.75,375.43s2.35,41.29,4,60.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M571.44,400.72c3.3-9,17.34-9,17.34-9-16,12.67-15.48,25-15.48,25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 681.17,
    cy: 370.04,
    rx: 9.62,
    ry: 33.89,
    transform: "translate(-58.4 137.74) rotate(-11.08)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "500.23 282.68 524.32 323.86 500.23 352.03 526.44 355.11 501.68 460.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "405.32 279.62 390.7 324.57 416.35 350.88 390.7 355.11 425.49 475.58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_12",
    "data-name": "Layer 12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411.11,693.65S437.44,552.52,425.71,496s76-5.56,76-5.56,9.53,135.65,24.77,203.24H477.83L463.41,590.07,451.87,693.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M461.93,499.44v56.91s10.8,1.49,11.65-7.2-.85-40.87-.85-40.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M435.67,509.76s40.61,6.22,59.58-2.4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 467.19,
    cy: 505.76,
    r: 3.35
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M480.36,281.29S506.07,350,501,487.92c-.72,19.46-75.31,8.35-75.31,8.35s-1.26-136.46-3.29-155.67-2.93-56.38-2.93-56.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.87,369.08l68.9-15.19a5.56,5.56,0,0,1,6.76,5.43V481a5.58,5.58,0,0,1-4.11,5.38l-74.07,19.86a5.57,5.57,0,0,1-7-5.6l5.17-126.31A5.56,5.56,0,0,1,394.87,369.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "412.97 356.18 413.91 367.95 444.45 362.4 444.45 349.96 412.97 356.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M444.45,414.33s22.14-18.83,29.35-17,12.05,14.51,12.58,16.62-1.75,4-1.75,4a11.86,11.86,0,0,1,1.82,4.68c.15,1.65-2.33,3.6-2.33,3.6s1.71,3.82,1.66,5.62a5.18,5.18,0,0,1-2.18,4s.43,1.42-1.23,5.35a20.72,20.72,0,0,1-5.82,8.16c-1.81,1.69-6,3.12-6,3.12V439.61s-22.9,3-26.08,1.14,0-26.42,0-26.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M475.93,432.31a4.24,4.24,0,0,0,1.67-4.69c-.68-3.37,3.46-3.87.11-7.56-2.44-2.7,3.16-5-.75-7.72-2.59-1.83,3.29-5,1.05-7.5s-.84-6.41-2.89-7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M476.06,441.09s-4.12.53-6.3-1.46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M341.16,454.55c10.79-19.79,34.19-32.38,62.26-41s41-16.2,41-16.2l-2.52,72-74.85,28.58S309.49,515.74,341.16,454.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M347.44,450.88s1.82-13.34,20.84-22.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M338.49,448.82s11.69-20.47,29.81-20.47c0,0,2-2.05,12.06-6.22s12.35-7.07,12.35-7.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_10",
    "data-name": "Layer 10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "426.9 266.05 474.5 268.42 475.76 285.05 425.32 285.05 426.9 266.05"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    "data-name": "Layer 8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M424.13,215.57s0,.25-.07.68c-.43,3.87-2.22,23.1,5.5,24.43,8.59,1.48,12.28-22.4,12.28-22.4l-7.39-19.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M429.68,218.28s2.53,49.67-1.28,64,22.08,26.59,36,16.41c7.49-5.49,6.52-8.54,6.52-8.54s-4.49-29.29,2.08-36.21S429.68,218.28,429.68,218.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M437.35,239.16s1.46,22.72,13.47,31.61c12.4,9.21,18.81.81,18.81.81s-.58-11.26,2.6-16.67C474.8,250.55,437.35,239.16,437.35,239.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M425.37,281.29l1.54-15.24,22.48,26.56v9.79S424.1,300.89,425.37,281.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "438.64 307.17 449.37 292.61 426.9 266.05 419.49 285.46 438.64 307.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M457.87,301.68l2.38-8.81,12.3-17.24.84,12.71S465.63,300.55,457.87,301.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "466.55 307.17 460.25 292.87 474.5 268.42 480.36 285.52 466.55 307.17"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M499.81,194.9s2.07,69.57-31.1,68.31c-26.55-1-38.75-38.49-38.75-38.49s-16,2.77-16.2-16.42c-.11-12.37,14.9-10.83,15.6-4.53s1.29-37.72,14.36-37.25S481.85,166.67,499.81,194.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M448.83,167.69s11.59,28.51,42.92,27.42,22.25-29,22.25-29-4.54-21.15-34.46-26-37,10.95-37,10.95-21.71,2.05-28.19,20.53c-4.08,11.59-1.65,23.94,4.06,28.17,8.49-.85,9,4.34,12.05,4.88,6.65,1.22,5.18-10,8.79-14.41S455.26,180.22,448.83,167.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M419,206.33c6.86-3.9,9.06,6.38,9.06,6.38s-2.42-3.73-6.45-2.18"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 463.41,
    cy: 209.09,
    rx: 3.14,
    ry: 4.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 490.25,
    cy: 209.09,
    rx: 3.14,
    ry: 4.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M454.8,201a23.46,23.46,0,0,1,14.85-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M485.19,197.91s6.22.28,10,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M478.33,209.18s4.31,10.81,3.56,14.53c-1.09,5.47-9.33,3.16-9.33,3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M462.23,233.16s12.34,5.41,20.65,1.54c-1.2,4.89-5.45,8.57-9,8.91C469.65,244,462.25,239,462.23,233.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M438,241.73s5.89,11.41,15.55,17.35c6.82,4.21,15.54,4.13,15.54,4.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M448.72,156.8s24.35,30.75,47.37,28.89c17.91-1.45,18.35-13.78,18.35-13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M445.86,153.69s43.39,37.45,67.62,12.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M443.79,151.43S482,178,509.72,159"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27",
    "data-name": "Layer 27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M992.8,234.91c13.72-26.63,13.72-63.62-17-91.24C945.86,116.72,856.12,70.34,767,123.13c-61.89,36.66-37.85,151.64,36.76,175.71,76.6,24.72,153.65-9.84,153.65-9.84l52.72,12.66S979.08,261.54,992.8,234.91Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_15",
    "data-name": "Layer 15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M670,361s9.78-6.07,10.12-7.43.5-14.49,2.36-17,8.93-12.15,12.14-13.14,13.31,2,13.31,2l1.52,1.18,9.1-8.42,6.07,1.53,1.86,9.94,1.52,8.08-.85,8.42,2,11a9.91,9.91,0,0,1-4.21,6.41c-3.87,2.86-18.19,11.47-23.09,12s-12.48.68-12.48.68-11.13,9.6-13.81,8.93C672.73,378.32,672.19,374.19,670,361Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M709.79,326.58c-8.62-12.83-31.44-51-13.49-72.28,22.74-27,75.53-1.76,90.79-7s-2.93-43.3,9.38-48.34S791.19,238,841,234.68,855.7,202.89,891.5,201s53.4,18.09,62.19-4.21-22.29-38.14-37-35.2,7.42,73.08-16.82,73.08,2.16-43-16.62-63.33-58.07-9.17-61.3,14.3-44.88,27.68-46.65,13.25,9.38-44.93,25.83-32.62c3.81,2.85,7,7.49,10,12.94,9.81,18,17.29,44.69,37.55,45.15,26.41.58,51-15.85,53.4-40.49s-6.45-67.46-43.42-56.9-50.46,33.43-7,37.55,62.18,1.76,59.25-16.43-50.46-14.07-55.14,8.8-74.5,41.51-8.21,81.49,89.19,10.71,91.54-3.71-24.56-16.14-77.45-37.87-8.21-11.14,11.15-17,65.44-6.45,53.84-25.82-83.76-21.22-114.85-.59-25.22,49.86-12.32,69.24,59.25,18.26,76.84,4.73,23.49-85.11,62.79-65.74,6.75,77.9-16.58,76.79S915.8,164.9,876.28,154s-81-14.07-68,28.76S887,259.32,905.67,251,866.53,188,866.53,188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M696.3,332.71s.66,11.16,7.61,11.69,7.35-2.11,7.35-2.11l-1.79-15.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M711.28,334.42s11.69-8.79,13.92-7.08,2.69,8.19,0,10.24c-5.35,4.08-15.63,12.91-20.37,11.46s-2.33-4.92-2.33-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M705.23,351.64c-1.45,1.95-1.45,6.42,3.28,6.55s17.86-11.82,17.86-11.82.88-10.24.2-10.84C715.34,345.51,706.67,349.66,705.23,351.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M709.55,359.47s-.23,5.68,5,4.55,10.78-6.46,10.78-6.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M725.33,361.52a3.19,3.19,0,0,1-2.81-1.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_25",
    "data-name": "Layer 25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M751.31,587s-73.54-42.7-41.76-101.71,7.89-122.57,7.89-122.57"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24",
    "data-name": "Layer 24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1185.98,
    y1: 913.57,
    x2: 1132.79,
    y2: 773.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 980.62,
    y1: 913.86,
    x2: 1033.81,
    y2: 774.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1000.37,771.27h175a22.62,22.62,0,0,0,22.55-22.55V746a22.62,22.62,0,0,0-22.55-22.55h-175A22.62,22.62,0,0,0,977.82,746v2.71A22.62,22.62,0,0,0,1000.37,771.27Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 980.28,
    y1: 748.7,
    x2: 984.98,
    y2: 748.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 994.81,
    y1: 748.7,
    x2: 1186.18,
    y2: 748.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1191.09,
    y1: 748.7,
    x2: 1195.79,
    y2: 748.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23",
    "data-name": "Layer 23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1257.56,460.17a26,26,0,0,0-4,11.22c-.89,8.27-.25,21.53,12.19,24.88S1297.27,478,1306,472.14c3.35-2.24,8.21-7.33,6.31-9.49-2.31-2.63-16.74,8.92-18.69,8.92-1.49,0,24.52-20.12,19-24.82-2.09-1.77-14.7,9.64-23.18,16.37.17-1.69,24.62-23.06,19.83-27.31-3.79-3.34-16.74,12.87-26.53,19.87,6.35-10.85,15.5-23,12.81-26.65s-23.13,28.84-26.91,30.38,1.47-21.25-5-22.43C1261.55,436.62,1263.14,451.45,1257.56,460.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.38,462.87a26.21,26.21,0,0,1,4,11.22c.88,8.27.24,21.54-12.2,24.88s-31.48-18.3-40.22-24.13c-3.34-2.23-8.21-7.33-6.31-9.49,2.31-2.63,16.74,8.93,18.7,8.93,1.48,0-24.53-20.13-19-24.83,2.08-1.76,14.69,9.65,23.17,16.37-.17-1.69-24.62-23.06-19.83-27.3,3.8-3.35,16.75,12.87,26.54,19.86-6.36-10.84-15.51-23-12.82-26.65s23.13,28.85,26.91,30.39-1.46-21.25,5-22.44C923.4,439.32,921.82,454.15,927.38,462.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1017.51,462.91c-15.52,19-19,28.66-22.83,48.24s-7,29.38-7,29.38-2.52,1.82-24.51-44.22c-6.39-13.38-22.42-2.45-22.42-2.45l-7-10.54-22.55,17.33,5.43,9.41s-10.45,5.85-9.19,16.3,14.62,16.4,26.31,37.45,23.59,53.49,50.54,47.77c20.84-4.41,35.93-28.82,35.93-28.82s-24.66,31.74-6.28,49.29,135.33,65.83,147,63.41,37.63-14,26.86-39.22c-4.93-11.5-8.37-36.72-8.37-36.72s38.08-3.07,57.3-37.76c20.41-36.84,36.76-44.28,36.58-58.9a13.76,13.76,0,0,0-8.37-12.78l6.26-9.94-19.64-20.75L1244.11,491s.82-13.46-10.87-9.26-19.62,21.83-25.46,29.52c-4.57,6-15.88,22.87-15.88,22.87l-25.41-64.48s-11.56-22.89-36.14-25.2c-.3-14.66-34.84-20-68.6-10.62-16.67,4.62-29.52,9.21-33.56,19.38A64.59,64.59,0,0,0,1017.51,462.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1054.44,448.46s-21.67,3.72-18.43,12.68,11.4,37.5,26.12,39.88,19.28-1.95,23-8.51,25.6-39.3,24.75-43.45-23.83-4.74-23.83-4.74,3.76,8.44-12.63,10.38C1053.8,457,1054.44,448.46,1054.44,448.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1174,547.5s9.86-14.73,17.93-13.48c-10.1,8.46-12.43,23.51-12.43,23.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M987.65,540.53s13.7,7.91,14,29.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1008.23,555.13s-5.47-16.09-20.58-13.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1143,520.87s2.82,18.17,3.44,29.13-3.39,64.69,33.07,69.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1022.66,525.57s5.51,19.11,4,31.95a114,114,0,0,1-6.43,25.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1066.92,502.34s3.93,29.17-2.29,49.84-9.34,38.58,1,54.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1077.67,501.7s7,1.18,7,19.17c0,17.23-9.06,24.75-3,36.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1060,501.7s-11,9.77-4.42,23.87-6.69,22.76-6.69,22.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1115.9,600.44l-8,6s14.42,17.21,28.51,26.61,19.11,6.26,19.11,6.26v-6.58S1131.12,626.45,1115.9,600.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1244.14,490.89c0,7.6,10.25,18.23,16.16,20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M940.74,493.84s-7.16,13.23-18.47,17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1146.4,508.18s.26-1.37.88-3.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1149.1,498.82a68,68,0,0,1,9.89-18.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1160.93,478.08c.82-.94,1.69-1.85,2.59-2.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1015.26,477.08s.49.9,1.26,2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1018.59,484.33c2.68,6.71,6,17.18,5.56,27.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1024,514.57c-.1.94-.23,1.86-.38,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1129.58,447.27s-6.18,19.91-27.4,35.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1029.67,458s2.84,17.36,10.53,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1109.94,449.06s2.31-4.4-5.28-8.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1090.36,453c.49,5.94-7.63,13.52-18.74,14.38-13.21,1-20.94-5.11-21.42-11.05s8.1-11.48,19.18-12.4S1089.85,447.11,1090.36,453Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_17",
    "data-name": "Layer 17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1029.07,415.66l49.09-2.23a22.33,22.33,0,0,0,21.29-23.32l-1-21.81A22.35,22.35,0,0,0,1075.13,347l-49.08,2.24a22.33,22.33,0,0,0-21.3,23.32l1,21.8A22.32,22.32,0,0,0,1029.07,415.66Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1089.08,393.24s-7,22.29-2.37,52.53c2.67,17.63-27.87,22.83-31.16,10-2.08-8.16.94-18.7-6.78-34.47C1040.46,404.33,1089.08,393.24,1089.08,393.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1056.49,439.4c3.55,1.64,8.46,2.5,15.32-5.37s10.73-24.4,10.73-24.4l-31.61,10.68S1052.92,437.77,1056.49,439.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1020.82,364.49s-1.54,25.69,4.12,39.88c5.73,14.39,22.19,27.7,28.81,25.63,21.33-6.61,24.77-15.41,28.79-20.41,19-23.54,31.57-24.58,30.93-40.08-.64-15.21-32.72-45.24-71.11-36.71C1022.42,337.26,1020.82,364.49,1020.82,364.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1048.18,358.72s3.18,3.18,10,3.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1032.12,360.32a18.28,18.28,0,0,1-6.92,3.78"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1053.2,
    cy: 371.18,
    rx: 3.31,
    ry: 4.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1029.22,
    cy: 372.1,
    rx: 3.31,
    ry: 4.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1041.42,372.1s-9.75,13.81-5.77,17.82,10,0,10,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1042,399.56a3.74,3.74,0,0,1,4-2.39c4.28.49,9.28,2.91,10.75,6.43,1.9,4.53-7,7.23-10.17,6.28C1043.71,409,1039.8,405.68,1042,399.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1046.21,397.77s17.5,5.38,6.84,10.73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1060,335.66s20.29,25.63,21.54,36.95c5.63-8.74,16.53-7.73,17,3.49a21.35,21.35,0,0,1-2.16,8.42c-4.12,8.61-9.6,6.19-9.6,6.19s-8,38,14.82,34.48c29.81-4.56,22.58-11.67,17.24-22-10.45-20.28,5.84-27.35.54-47.21s-16.8-27.91-30.59-31.46C1076.92,321.42,1065.32,326.34,1060,335.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1069.65,327.09S1058,344.17,1037,352.57c-13.48,5.38-18,11-21,16.05-6.71,11.05-1.88,27.72,11,42.7,11.31,13.12-57.21,23-32-4.66,10.51-11.52-34-46.25,17.72-69,20.52-9,30.47-32.11,72.19-12.91C1078.44,328.56,1069.65,327.09,1069.65,327.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1060,326.83s-5.94,17.06-29.92,21.8c-20.81,4.11-27.51,19.51-24.9,32.7a31.22,31.22,0,0,0,9.23,16.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1085.7,379.86s1.56-10,6.91-8.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1085.7,380.69s4.51-6.31,8-3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1082.54,409.61s-10.06,17.76-29.36,20.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1070.27,335.15s29.09,9.64,34.29,25.17c6.56,19.54-12.1,37.57-10.24,48.2,1.47,8.33,10.24,8.65,10.24,8.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1070.27,335.15s40.83,1.09,43.22,26.75c2,21.06-19.56,41.89-5.35,49.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1060,326.83s-8.35,10.48-34.06,14.13S991.22,365.9,994,378.53c4.5,20.52,24.27,27.31,8.57,37.34"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_20",
    "data-name": "Layer 20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.7,881.23s6.35,9.19,6.82,13.66.81,21,.81,21L1011,917.78l.32-20.14a20.2,20.2,0,0,1,10.69-15c3.76-1.13,1.62-38.56,1.62-38.56h36.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1062.28,886.46c-2.29-3.63-19.21-11.77-38.24-4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1032.29,845.05s8.43,10.17,17.79,15.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1051.81,844.77s-5.11,9.49-17.8,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1035.52,861.87s9.51,12.39,16.67,13.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1049.48,862.66s-2.86,11.9-14,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M960.76,795.4l-12.2,19v12.34l-19.22,28.49-98.29-64.81s11.39-12.26,16.05-16.11,17.17-9,34.82-.77a60.3,60.3,0,0,1,17.74,13.15l24.51-6.4,13.17-18,23.42,33.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "836.48 779.48 938.71 849.94 933.04 858.34 829.24 790.33 836.48 779.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M902,800.74a16.25,16.25,0,0,0-2.35-14.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M936.23,766.67s-1.12,12.4,2.48,18.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 929.49,
    y1: 777.13,
    x2: 944.84,
    y2: 774.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M927.38,778.41s-6.16,11.52-1.69,18.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 917.44,
    y1: 783.6,
    x2: 934.92,
    y2: 789.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M915,785s-7.68,8.78-8.6,14.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M903.53,785s9.14,10.66,14.64,11.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1002.39,
    y: 911.51,
    width: 70.63,
    height: 9.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    "data-name": "Layer 19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1136.61,724.49s22.77-14.88,21.29-33.73-11.39-31.2-42.08-46.06-68.35-52.13-95.56-50.09-56.42,114.15-89.08,155.12c12.38,30.51,50.5,69.2,50.5,69.2l42.56-117.64,42.08,22.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1032.42,651.26s-20.22.52-23.12,23.17-1.92,173.82-1.92,173.82,53.45,3.85,79-7.71c-9.15-42.38-27-162.41-31.29-172.37S1045.89,652.22,1032.42,651.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1157.64,696.38a18,18,0,0,1-1.79,3.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1150.38,705.06c-6,3.74-16.22,4.66-32.43-8.68-25.53-21-48.1-30.31-59.22-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1055,661.2c-2.35-.68-3.63-1-3.63-1s.26,1.32.71,3.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1053.47,671.55c1.61,9.55,3.85,24.27,5.39,40.82,2.57,27.74,3.68,62,18.55,124"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1078.31,840.11c.3,1.2.6,2.43.9,3.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M964.48,799.86c.64-1.08,1.26-2.17,1.9-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M970.06,790c21-38.64,33-79.16,37.36-95.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1008.38,691c.6-2.35.9-3.65.9-3.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1066.32,723.44s-8.08-48.16-14.92-63.18c-2.05-4.49-11.32-9-22.08-7.24-18.18,3-20,34.3-20,34.3l-2.07,61.4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontImage3);
export default __webpack_public_path__ + "static/media/FrontImage3.344099eb3674ab5df46aad5862b8a994.svg";
export { ForwardRef as ReactComponent };